import React, { useContext, useEffect } from "react";
import { getSortedOwnerLabels, initialOwnersFilter } from "./FilterTypes/OwnerFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiUserList from "components/Picker/UserPicker/MultiUserList";

interface Props {
  title?: string
}

const OwnersFilter = (props: Props) => {
  const title = props.title || RESX.GeneralLabels.Owner;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("owners", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedOwnerLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedOwners.length > 0,
    reset: () => initialOwnersFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedOwners.map(s => s.userId), b.selectedOwners.map(s => s.userId))
  });
  useEffect(() => {
    setInitialValue("owners", initialOwnersFilter);
  }, []);

  const [selectedOwners, setSelectedOwners] = React.useState<server.dto.UserSmall[]>(initialOwnersFilter.selectedOwners);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedOwners(getValue("owners").selectedOwners);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("owners", { selectedOwners });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiUserList
        value={selectedOwners}
        onChange={setSelectedOwners}
        excludeKeys={selectedOwners.map(u => u.userId)}
        canChooseDeactivated
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default OwnersFilter;
